import { render, staticRenderFns } from "./NavbarItem.vue?vue&type=template&id=94379488"
import script from "./NavbarItem.vue?vue&type=script&lang=ts"
export * from "./NavbarItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports